import React, { useState } from 'react';
import styled from 'styled-components';
import { Collapse } from '@mui/material';
import ArticleIcon from '@mui/icons-material/Article';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { useNavigate } from 'react-router-dom';

const StyledRow = styled.div`
  cursor: pointer;
  font-size: 0.875rem;
  padding: 6px 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  &:hover {
    background-color: #F0F7FF;
  }
`;

const StyledIcon = styled.div`
  display: inline-block;
  padding-top: 4px;
  margin-right: 4px;
  transition-duration: 0.5s;
  transform-origin: center center;
  transform: ${props => props.isOpen ? "rotate(0deg)" : "rotate(180deg)"};
`;

const DocMenus = ({menus}) => {
  const [showChildren, setShowChildren] = useState(true);
  const navigate = useNavigate();

  return (
    <div style={{marginTop: '10px'}}>
      <StyledRow style={{ fontWeight: 'bold'}} onClick={() => setShowChildren(!showChildren)}>
        <div style={{display: 'flex'}}>
          <div style={{width: '30px'}}>
            <ArticleIcon style={{width: '24px', height: '20px', color: '#1976d2'}} />          
          </div>
          <span style={{fontSize: '18px'}}>{menus.name}</span>
        </div>
        <StyledIcon isOpen={showChildren}>
          <ExpandLessIcon style={{width: '24px', height: '20px', color: '#1976d2'}} />
        </StyledIcon>
      </StyledRow>
      <Collapse in={showChildren}>
        {menus.children.map((item, index) => {
          return (
            <StyledRow key={index} style={{paddingLeft: '40px', fontWeight: '500'}} onClick={() => navigate(item.link)}>
              {item.name}
            </StyledRow>
          )
        })}
      </Collapse>

    </div>
  )
}

export default DocMenus;
